<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入名称"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="ROI系数" prop="roi_coefficient">
        <el-input
          v-model="form.roi_coefficient"
          placeholder="请输入ROI系数"
          style="width: 100%"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { placementCreate, placementUpdate } from '@/api/notify.js'

export default {
  name: 'PlacementDialog',
  data() {
    return {
      dialogVisible: false,
      dialogType: 1, // 1: 新增, 2: 编辑
      form: {
        id: null,
        name: '',
        roi_coefficient: ''
      },
      formRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        roi_coefficient: [
          { required: true, message: '请输入ROI系数', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.dialogType === 1 ? '新增投放位置' : '编辑投放位置'
    }
  },
  methods: {
    // 打开弹窗
    open(type, row = null) {
      this.dialogType = type
      if (type === 1) {
        // 新增
        this.form = {
          id: null,
          name: '',
          roi_coefficient: ''
        }
      } else {
        // 编辑
        this.form = {
          id: row.id,
          name: row.name || '',
          roi_coefficient: row.roi_coefficient || ''
        }
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    // 关闭弹窗
    handleClose() {
      this.form = {
        id: null,
        name: '',
        roi_coefficient: ''
      }
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
    },
    // 提交
    async handleSubmit() {
      this.$refs.formRef.validate(async(valid) => {
        if (!valid) return
        try {
          if (this.dialogType === 1) {
            // 新增
            const res = await placementCreate({
              name: this.form.name,
              roi_coefficient: this.form.roi_coefficient
            })
            if (res && res.success) {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.message || '新增失败')
            }
          } else {
            // 编辑
            const res = await placementUpdate({
              id: this.form.id,
              name: this.form.name,
              roi_coefficient: this.form.roi_coefficient
            })
            if (res && res.success) {
              this.$message.success('修改成功')
              this.dialogVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.message || '修改失败')
            }
          }
        } catch (err) {
          console.error(err)
          this.$message.error('操作失败，请稍后重试')
        }
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>

